import { createFileRoute } from '@tanstack/react-router';
import { ScheduledPostsView } from '@/components/feed/ScheduledPostsView';

// The author's scheduled-posts management page (#494). The composer's
// "Schedule" flow navigates here on success; each post's `Cancel` deletes it
// before it publishes.
export const Route = createFileRoute('/_authed/feed/scheduled')({
  component: ScheduledPostsPage,
});

function ScheduledPostsPage() {
  return <ScheduledPostsView />;
}
